import React from 'react';
import { Heading } from '../../components';
import { richText } from '../../util/richText';

import css from './ListingPage.module.css';
import { useIntl } from 'react-intl';

const MIN_LENGTH_FOR_LONG_WORDS = 20;

const SectionTextMaybe = props => {
  const { text, heading, showAsIngress = false } = props;
  const textClass = showAsIngress ? css.ingress : css.text;
  const intl = useIntl();
  const content = richText(text, {
    linkify: true,
    longWordMinLength: MIN_LENGTH_FOR_LONG_WORDS,
    longWordClass: css.longWord,
    breakChars: '/',
  });

  return text ? (
    <section className={css.sectionText}>
      <Heading as="h2" rootClassName={css.sectionHeading}>
        {intl.formatMessage({ id: 'SectionTextMaybe.aboutTheSpace' })}
      </Heading>

      <p className={textClass}>{content}</p>
    </section>
  ) : null;
};

export default SectionTextMaybe;
